var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7921 16.6734L17.8994 12.301C17.1065 11.7971 16.1074 11.7705 15.2903 12.2303C14.472 12.691 13.9648 13.5648 13.9648 14.5139V23.3911C13.9648 24.3401 14.472 25.2139 15.2903 25.6747C16.1075 26.1345 17.1066 26.1079 17.8994 25.604L24.7921 21.2315C25.5452 20.7561 26.0018 19.919 26 19.0186V18.8865C26.0018 17.9861 25.5452 17.149 24.7921 16.6736V16.6734ZM24.1484 19.0185C24.1484 19.27 24.0209 19.5031 23.8103 19.6362L16.9185 24.0115C16.6961 24.1519 16.4158 24.1602 16.187 24.0308C15.9583 23.9023 15.8164 23.6572 15.8164 23.391V14.5138C15.8164 14.2476 15.9583 14.0026 16.187 13.8741C16.4158 13.7447 16.696 13.7529 16.9185 13.8933L23.8103 18.2686C24.0209 18.4017 24.1484 18.6348 24.1484 18.8863V19.0185Z",
    fill: "#3B4858"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.7125,
    y: 0.7125,
    width: 36.575,
    height: 36.575,
    rx: 18.2875,
    stroke: "#3B4858",
    strokeWidth: 1.425
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.5ef7e214762253722964ae3eb4dee6e2.svg";
export { ForwardRef as ReactComponent };